/* eslint-disable new-cap */
import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';

export default class OilSlick extends Phaser.GameObjects.Image {
  constructor(scene) {
    super(scene, 0, 0, ABCyaPhaser.Images.DEFAULT_ATLAS, 'oil1');
    scene.add.existing(this);

    this.scene = scene;
    this.speed = 400;
    this.isActive = true;
    this.beenHit = false;
    this.vY = 0;

    this.workingWidth = this.getBounds().width;
    this.workingHeight = this.getBounds().height;
    this.boundries = {
      left: this.x - this.workingWidth / 2,
      right: this.x + this.workingWidth / 2,
      top: this.y - this.workingHeight / 2,
      bottom: this.y + this.workingHeight / 2
    };
  }

  reset(startX, startY) {
    this.beenHit = false;
    const whichone = Phaser.Math.Between(0, 100);
    const sn = whichone < 50 ? 1 : 2;
    this.setTexture(ABCyaPhaser.Images.DEFAULT_ATLAS, `oil${sn}`);
    this.workingWidth = this.getBounds().width;
    this.workingHeight = this.getBounds().height;
    this.x = startX;
    this.y = startY;

    this.setVisible(true);
  };

  update(e, trackSpeedMod) {
    const tSpeed = !trackSpeedMod ? 0 : trackSpeedMod;
    this.vY = tSpeed;
    const dtime = e / 1000;
    this.y += this.vY * dtime;
    this.boundries.left = this.x - this.workingWidth / 2;
    this.boundries.right = this.x + this.workingWidth / 2;
    this.boundries.top = this.y - this.workingHeight / 2;
    this.boundries.bottom = this.y + this.workingHeight / 2;
  };
}